import { Button, Loader, Modal, Tooltip } from '@mantine/core';
import { useClipboard } from '@mantine/hooks';
import React from 'react';
import { useParams } from 'react-router';
import LinkIcon from '../../assets/LinkIcon';
import PublishIcon from '../../assets/PublishIcon';
import useFirebaseFunction from "../../utils/useFirebaseFunction";
import useGetFeaturedPhotos from '../../utils/useGetFeaturedPhotos';
import ErrorIcon from '../../assets/ErrorIcon';

const ModalPublishComponent = ({board, opened,setOpened}) => {
    const [set_board_subdomain, isSetLoading] = useFirebaseFunction("set_board_subdomain", "europe-west1");
    const {data: featuredPhotos ,isLoading} = useGetFeaturedPhotos(board);
    const { subdomain } = useParams();

    const save = () => {
        set_board_subdomain({board}).then((data) => {
            if (data) {
                window.location.reload();
                setOpened(false);
            }
        })
    }

    const clipboard = useClipboard({ timeout: 1000 });

    const disableAnimation = {
        root: {
            '&:not(:disabled)': {
                '&:active': {
                    transform:'none'
                }
            }
        }
    }

    return (
        <Modal
            centered={true}
            opened={opened}
            setOpened={setOpened}
            withCloseButton={false}
            onClose={() => setOpened(false)}
            className="mx-2"
        >
            <div className="bg-white flex flex-col justify-center items-center">
                {!isLoading ? 
                <div className="flex flex-col justify-center items-center">

                    {featuredPhotos < 10 ? 
                        <ErrorIcon width={45} height={45} />
                    :
                        <div className="rounded-full p-5 flex relative justify-center w-[100px] h-[100px] items-center border-4 border-[#3C3C3C]">
                            <PublishIcon width={55} height={55} className="absolute top-1/2 left-1/2 transform -translate-x-[57%] -translate-y-1/2" fill="#3C3C3C" />
                        </div>
                    }

                    <h1 className={`text-[#3C3C3C] font-[600] text-[20px] mt-2 ${featuredPhotos < 10 ? 'mb-1 mt-5' : 'mb-6'}`}>{featuredPhotos < 10 ? 'Planșa nu a putut fi publicată' : 'Publică planșă'}</h1>
                    {featuredPhotos < 10 && 
                        <p className="text-sm mb-10">Este necesar să evidențiezi cel putin 10 fotografii</p>
                    }
                    
                    {featuredPhotos >= 10 && 
                    <Button
                        styles={disableAnimation}
                        style={{background:'transparent',height:'fit-content',border:'2px solid', borderColor:'#3c3c3c',display:'flex', alignItems:'center', marginBottom:'42px', padding:'10px 16px',borderRadius:'6px'}}
                        onClick={() => clipboard.copy(`https://picboard.ro/${subdomain}`)}
                    >
                        <Tooltip opened={clipboard.copied} label={'Copied'} withArrow position="top">
                            <div className="flex items-center gap-x-3">
                                <LinkIcon width={18} height={18} fill="#3C3C3C" />
                                <p className="font-[500] text-base leading-[1.75rem] text-[#3C3C3C]">https://picboard.ro/{subdomain}</p>
                            </div>
                        </Tooltip>
                    </Button>}

                </div>
                :
                <div className="py-6 flex justify-center items-center"><Loader /></div>}

                
                {!isLoading && 
                <div className="flex justify-center items-center gap-x-6">
                    {featuredPhotos < 10 ? 
                        <Button radius="sm" style={{width:'125px'}} loading={isSetLoading} onClick={() => setOpened(false)}> Am înțeles</Button>
                    :
                        <>
                        <Button variant="default" style={{width:'125px'}} color="gray" onClick={() => setOpened(false)} >Anulează</Button>
                        <Button radius="sm" style={{width:'125px'}} loading={isSetLoading} onClick={() => save()}> Publică</Button>
                        </>
                    }
                </div>}
            </div>
        </Modal>
    )
}

export default ModalPublishComponent